import { render, staticRenderFns } from "./aWorkDetailEvent.vue?vue&type=template&id=c62f09fc&scoped=true"
import script from "./aWorkDetailEvent.vue?vue&type=script&lang=js"
export * from "./aWorkDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailEvent.vue?vue&type=style&index=0&id=c62f09fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f09fc",
  null
  
)

export default component.exports